module.exports = __webpack_public_path__ + "img/logo-spotvnow-l.3ab7a409.png";